
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorService } from '../services/error.service';
import { ErrorModel } from '../models/error.model';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {
  }

  async handleError(error: Error | HttpErrorResponse) {

    const errorService = this.injector.get(ErrorService);

    if (error instanceof HttpErrorResponse) {
      // Server error
      // message = errorService.getServerErrorMessage(error);
    } else {
      // Client Error
      const err = this.getErrorModel(error);
      errorService.setError(err.message);
    }
    console.error(error);
  }


  getErrorModel(error: any): ErrorModel {
    let errorModel: ErrorModel;
    try {
      errorModel = JSON.parse(error.message);
    } catch (e) {
      if (error.rejection instanceof ErrorModel) {
        return error.rejection;
      }
      return error;
    }
    return errorModel;
  }
}
